export const environment = {
  production: true,
  homol: false,
  apiUrl: 'https://sra.idus.com.br/api/v1',
  context: 'api',
  projectName: 'IDUS-SRA',
};
